import { render, staticRenderFns } from "./pdf.vue?vue&type=template&id=066c296b&scoped=true&"
import script from "./pdf.vue?vue&type=script&lang=js&"
export * from "./pdf.vue?vue&type=script&lang=js&"
import style0 from "./pdf.vue?vue&type=style&index=0&id=066c296b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066c296b",
  null
  
)

export default component.exports